import React, { Component } from "react";
import Moment from "react-moment";
import { Icon } from "react-materialize";
import { withRouter } from "react-router";

import Properties from "../properties/Properties";
import DownloadsList from "../downloads-list/DownloadsList";
import BulkDownload from "../bulk-download/BulkDownload";
import SubmissionConstants from "../../constants/SubmissionConstants";
import CommonConstants from "../../constants/CommonConstants";

import "./SubmissionDetails.css";

const SUBMISSION_PROPERTIES_TO_SHOW = [
  {
    displayName: "Line of Business",
    name: "archive_submission:lineOfBusiness",
  },
  {
    displayName: "Workfront Project Job ID",
    name: "archive_submission:workfrontProjectJobId",
  },
  {
    displayName: "Contract",
    name: "archive_submission:contract",
  },
  {
    displayName: "Product Category ID",
    name: "archive_submission:productCategoryId",
  },
  {
    displayName: "Product Category Name",
    name: "archive_submission:productCategoryName",
  },
  {
    displayName: "Product Type ID",
    name: "archive_submission:productTypeId",
  },
  {
    displayName: "Product Type Name",
    name: "archive_submission:productTypeName",
  },
  {
    displayName: "Product Detail ID",
    name: "archive_submission:productDetailId",
  },
  {
    displayName: "Product Detail Name",
    name: "archive_submission:productDetailName",
  },
  {
    displayName: "Workfront Project ID",
    name: "archive_submission:workfrontProjectId",
  },
  {
    displayName: "Licensee Ref #",
    name: "archive_submission:licenseeRefNo",
  },
  {
    displayName: "LicenseeName",
    name: "archive_submission:licenseeName",
  },
  {
    displayName: "Licensee Phone",
    name: "archive_submission:licenseePhone",
  },
  {
    displayName: "Licensee Fax",
    name: "archive_submission:licenseeFax",
  },
  {
    displayName: "Licensee E-Mail",
    name: "archive_submission:licenseeEmail",
  },
  {
    displayName: "Licensee Contact Name",
    name: "archive_submission:licenseeContactName",
  },
  {
    displayName: "Property",
    name: "archive_submission:property",
  },
  {
    displayName: "Property Name",
    name: "archive_submission:propertyName",
  },
  {
    displayName: "Territory",
    name: "archive_submission:territory",
  },
  {
    displayName: "Contract Status",
    name: "archive_submission:contractStatus",
  },
  {
    displayName: "Art Program",
    name: "archive_submission:artProgram",
  },
  {
    displayName: "AE Name",
    name: "archive_submission:aeName",
  },
  {
    displayName: "BA Rep",
    name: "archive_submission:baRep",
  },
  {
    displayName: "PD",
    name: "archive_submission:pd",
  },
  {
    displayName: "Description",
    name: "dc:description",
  },
  {
    displayName: "Title",
    name: "dc:title",
  },
  {
    displayName: "Coordinator",
    name: "archive_submission:coordinator",
  },
  {
    displayName: "Job Status",
    name: "archive_submission:jobStatus",
  },
  {
    displayName: "Licensee",
    name: "archive_submission:licensee",
  },
  {
    displayName: "Retailer",
    name: "archive_submission:retailer",
  },
  {
    displayName: "LMSI Office",
    name: "archive_submission:lmsiOffice",
  },
  {
    displayName: "Job Stage",
    name: "archive_submission:jobStage",
  },
  {
    displayName: "Job Category",
    name: "archive_submission:jobCategory",
  },
  {
    displayName: "Job Start Date",
    name: "archive_submission:jobStartDate",
  },
  {
    displayName: "Character",
    name: "archive_submission:character",
  },
  {
    displayName: "Job Stage Category",
    name: "archive_submission:jobStageCategory",
  },
  {
    displayName: "Job Last Status Date",
    name: "archive_submission:jobLastStatusDate",
  },
];

const PRODUCT_PROPERTIES_TO_SHOW = [
  {
    displayName: "SKU",
    name: "prd_sku",
  },
  {
    displayName: "Internal Ref ID",
    name: "prd_internalRefId",
  },
  {
    displayName: "UPC",
    name: "prd_upc",
  },
];

class SubmissionPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isBulkDownload: false,
      selectedFiles: new Map(),
    };

    this._handleBulkDownload = this._handleBulkDownload.bind(this);
    this._handleFileListChanged = this._handleFileListChanged.bind(this);
  }

  static PAGE_PATH = "/submission/:id";

  _handleBulkDownload() {
    this.setState({ selectedFiles: new Map() }, () => {
      this.setState({ isBulkDownload: !this.state.isBulkDownload });
    });
  }

  _handleFileListChanged(event) {
    let selectedFiles = this.state.selectedFiles;

    if (event.details.deletedFile) {
      selectedFiles.delete(event.details.deletedFile);
    } else {
      selectedFiles = new Map([
        ...selectedFiles,
        ...event.details.selectedFiles,
      ]);
    }

    this.setState({ selectedFiles: selectedFiles });
  }

  render() {
    const hrefLink = "#";
    const { submission } = this.props;

    if (!submission) {
      return <div />;
    }

    const { selectedFiles } = this.state;
    return (
      <div className="submission-details">
        <div className="main">
          <header className="main-header">
            <a
              href={hrefLink}
              className="btn-link"
              onClick={this.props.history.goBack}>
              <Icon tiny>arrow_back</Icon> Back
            </a>
          </header>

          <div>
            <h2 className="submission-id">{submission.title}</h2>
          </div>

          <div className="items">
            <div className="item">
              <label>Last Modified</label>
              {submission.lastModified ? (
                <Moment format={CommonConstants.NUXEO_DATE_FORMAT}>
                  {submission.lastModified}
                </Moment>
              ) : (
                "-"
              )}
            </div>
            <div className="item">
              <label>Created</label>
              {submission.properties["dc:created"] ? (
                <Moment format={CommonConstants.NUXEO_DATE_FORMAT}>
                  {submission.properties["dc:created"]}
                </Moment>
              ) : (
                "-"
              )}
            </div>
          </div>

          <Properties
            object={submission.properties}
            properties={SUBMISSION_PROPERTIES_TO_SHOW}
          />
          <div className="products-list">
            <div className="accordion">
              <label>Products</label>
              <div className="accordion-content">
                <Properties
                  object={submission.properties["archive_submission:product"]}
                  properties={PRODUCT_PROPERTIES_TO_SHOW}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="side">
          <BulkDownload
            allFiles={submission.associatedFiles}
            submissionTitle={submission.title}
            selectedFiles={selectedFiles}
            onBulkDownloadChanged={this._handleBulkDownload}
            isBulkDownload={this.state.isBulkDownload}
          />

          <DownloadsList
            title="Download PAR Forms"
            files={
              submission.associatedFiles[SubmissionConstants.FILE_TYPE_PAR_FORM]
            }
            onFileListChanged={this._handleFileListChanged}
            selectedFiles={this.state.selectedFiles}
            isBulkDownload={this.state.isBulkDownload}
          />

          <DownloadsList
            title="Download Job Histories"
            files={
              submission.associatedFiles[
                SubmissionConstants.FILE_TYPE_JOB_HISTORY
              ]
            }
            onFileListChanged={this._handleFileListChanged}
            selectedFiles={this.state.selectedFiles}
            isBulkDownload={this.state.isBulkDownload}
          />

          <DownloadsList
            title="Download Assets"
            files={
              submission.associatedFiles[SubmissionConstants.FILE_TYPE_ASSET]
            }
            onFileListChanged={this._handleFileListChanged}
            isBulkDownload={this.state.isBulkDownload}
            selectedFiles={this.state.selectedFiles}
            showThumbnails
          />
        </div>
      </div>
    );
  }
}

export default withRouter(SubmissionPage);
